<template>
  <div class="micro-header">
    <div class="head-left">
      <img src="~_a/logo.png" alt="" />
      <div class="t1">通用平台</div>
      <div class="line"></div>
      <!-- <IviewSelect v-model="defaultVal" :optionList="organList" @on-change="setDefaultOrgan" /> -->
    </div>
    <!-- <el-button class="back-home" @click="$router.push({ path: $route.path })">返回后台</el-button> -->
    <el-button class="back-home" v-if="!isHome" @click="backTo">返回后台</el-button>
    <UserAvatar />
    <IviewModal
      title="提示"
      type="confirm"
      v-model="tipPopup"
      @on-ok="tipPopup = false"
      confirmText2="所选组织未设置所属部门，请联系管理员进行设置。"
    >
    </IviewModal>
  </div>
</template>

<script>
import UserAvatar from '@/components/common2/userAvatar.vue'
import { getUserInfo } from '@/utils/common'
export default {
  components: { UserAvatar },
  name: 'Header',
  props: {
    isHome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      organList: [],
      defaultVal: '',
      tipPopup: false
    }
  },
  created() {
    this.$api.config.getOrganSelect({ belongGroup: 1 }).then((res) => {
      this.organList = res.data.map((item) => ({ ...item, label: item.groupName, value: item.groupId }))
      this.getDefaultOrgan()
    })
  },
  mounted() {
    console.log(this.$route);
  },
  methods: {
    backTo() {
      this.$router.push(this.$parent.backPath)
    },
    async setDefaultOrgan() {
      let data = this.organList.find((item) => item.groupId == this.defaultVal)
      if (data.belongGroup == 0) {
        this.$alert('所选组织未设置所属部门，请联系管理员进行设置。', '提示', {
          confirmButtonText: '确定'
        })
        this.getDefaultOrgan()
      } else {
        let { id } = await getUserInfo()
        this.$api.config.putDefaultOrgan({}, [id, this.defaultVal]).then(async (res) => {
          await getUserInfo(true)
          location.reload()
        })
      }
    },
    getDefaultOrgan() {
      let data = this.organList.find((item) => item.defaultGroup == 1)
      if (data) {
        this.defaultVal = data.groupId
      }
    }
  }
}
</script>

<style lang="less" scoped>
.micro-header {
  position: relative;
  width: 100%;
  height: 64px;
  padding: 0 40px 0;
  background: #374159;
  box-shadow: 0px 4px 20px 0px rgba(116, 122, 138, 0.83);
  display: flex;
  align-items: center;
  justify-content: space-between;
  .head-left {
    display: flex;
    align-items: center;
    flex: 1;
    img {
      width: 30px;
    }
    .t1 {
      font-size: 24px;
      font-family: Helvetica;
      color: #ffffff;
      letter-spacing: 2px;
      text-shadow: 1px 1px 1px rgba(32, 38, 52, 0.74);
      margin-left: 16px;
    }
    .line {
      width: 1px;
      height: 24px;
      border: 1px solid #ffffff90;
      margin: 0 20px 0 40px;
    }
    /deep/.ivu-select {
      .ivu-select-selection {
        width: 240px;
        height: 30px;
        // background: #515c79 !important;
        border-radius: 4px;
        border: none !important;
      }
    }
  }
  .back-home {
    // margin-left: 1300px;
    margin-right: 20px;
  }
}
</style>
